import React from 'react';
import { Helmet } from 'react-helmet-async';

const env = {
  baseUrl: process.env.REACT_APP_BASE_URL || '',
  locale: process.env.REACT_APP_LOCALE || 'tr-TR',
  indexable: String(process.env.REACT_APP_INDEXABLE).toLowerCase() !== 'false',
  siteName: process.env.REACT_APP_SITE_NAME || 'Pine',
  siteDesc: process.env.REACT_APP_SITE_DESC || '',
};

const domains = {
  tr: 'https://pinerandevu.com',
  en: 'https://pinebooking.com',
};

export default function SEO({
  title,
  description,
  path = '/',
}) {
  const trToEn = {
    '/': '/',
    '/hizmetler': '/services',
    '/iletisim': '/contact',
    '/randevu-sorgula': '/booking/search',
    '/demo-talebi': '/demo-request',
    '/basarili': '/success',
  };
  const enToTr = Object.fromEntries(Object.entries(trToEn).map(([tr, en]) => [en, tr]));

  const cleanPath = path || '/';
  const url = `${env.baseUrl}${cleanPath === '/' ? '/' : cleanPath}`;
  const pageTitle = title ? `${title} | ${env.siteName}` : env.siteName;
  const desc = description || env.siteDesc;
  const isTR = (env.locale || '').toLowerCase().startsWith('tr');

  const altTr = isTR ? cleanPath : (enToTr[cleanPath] || cleanPath);
  const altEn = isTR ? (trToEn[cleanPath] || cleanPath) : cleanPath;

  const hrefLangs = [
    { hrefLang: 'tr-TR', href: `${domains.tr}${altTr}` },
    { hrefLang: 'en', href: `${domains.en}${altEn}` },
    { hrefLang: 'x-default', href: `${domains.tr}${altTr}` },
  ];

  return (
    <Helmet>
      <html lang={isTR ? 'tr' : 'en'} />
      <title>{pageTitle}</title>
      {desc && <meta name="description" content={desc} />}

      {/* Canonical */}
      {env.baseUrl && <link rel="canonical" href={url} />}

      {/* Robots */}
      <meta name="robots" content={env.indexable ? 'index, follow' : 'noindex, nofollow'} />

      {/* Hreflang */}
      {hrefLangs.map((l) => (
        <link key={l.hrefLang} rel="alternate" hrefLang={l.hrefLang} href={l.href} />
      ))}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={env.siteName} />
      <meta property="og:title" content={pageTitle} />
      {desc && <meta property="og:description" content={desc} />} 
      {env.baseUrl && <meta property="og:url" content={url} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      {desc && <meta name="twitter:description" content={desc} />} 
    </Helmet>
  );
}
